import {Component, OnInit}              from '@angular/core';
import {ModalController, NavController} from '@ionic/angular';
import {EditContractPage}               from '../edit-contract/edit-contract.page';
import {ActivatedRoute}                 from '@angular/router';
import {DataStore}                      from '@aws-amplify/datastore';
import {Contract, User as UserModel}    from '../../models';
import {S3LinkPipe}                     from '../pipes/s3-link.pipe';
import {SessionService}                 from '../services/session.service';
import {ContractStatus}                 from '../enums/enums';
import {ToastServiceHelperService}      from "../services/toast-service-helper.service";
import {Browser}                        from '@capacitor/browser';
import {DocumentViewer}                 from '@awesome-cordova-plugins/document-viewer/ngx';
import {ModalService}                   from "../services/modal.service";

@Component({
    selector: 'app-contract',
    templateUrl: './contract.page.html',
    styleUrls: ['./contract.page.scss'],
})
export class ContractPage implements OnInit {
    contractId;
    currentContract: Contract;
    contractStatus = ContractStatus;
    utenti;

    constructor(
            private document: DocumentViewer,
            private modalService: ModalService,
            private route: ActivatedRoute,
            private navController: NavController,
            private modalController: ModalController,
            private s3LinkPipe: S3LinkPipe,
            public sessionService: SessionService,
            private toastService: ToastServiceHelperService,
    ) {

    }

    async ngOnInit() {
        await this.route.params.subscribe(params => {
            this.contractId = params['contractId'];
        });

        await this.refreshContract();
        this.utenti = await DataStore.query(UserModel, this.currentContract.clientId);
        

    }

    ionViewDidEnter() {
        // make sure the newly styled content scrolls when needed
        document.querySelectorAll('.main-content')[document.querySelectorAll('.main-content').length - 1].shadowRoot.querySelector('.inner-scroll').setAttribute('style', 'height:100%');
    }

    async editContract() {
        this.modalService.contractEdit(this.currentContract.id).then(d => {
            this.refreshContract();
        });

    }

    async deleteContract(contractId: string) {
        if (confirm('Sicuro di voler cancellare questo contratto ?')) {
            await DataStore.delete(Contract, contractId);
            this.back();
        }
    }

    private async refreshContract() {
        this.currentContract = await DataStore.query(Contract, this.contractId);

    }

    back() {
        this.navController.back();
    }

    async open(file: any) {
        let fileToOpen: string = await this.s3LinkPipe.transform(file);
        
        if (fileToOpen) {


            if (fileToOpen.startsWith('asset'))
                await this.toastService.error('Nessun contratto presente');
            else {
                await Browser.open({url: encodeURI(fileToOpen)},);
                //  await this.document.viewDocument(fileToOpen, 'application/pdf',{});
            }
        } else {
            await this.toastService.error('Nessun contratto presente');

        }
    }

    openPage(s: string) {

    }
}
